import { PaginasMenuAttributes } from "@fl/shared/src/types/models/suporte_fl/paginas_menus";
import { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import { useAuth } from "../../context/auth";
import { useMenuContext } from "../../context/menus";
import { checkMenus } from "../../utils/authFuncs";
import StringsFuncs from "../../utils/stringsFuncs";
import NotificationsIconMenu from "./notifications";

const PrivateMenu = () => {
  const { authToken } = useAuth();
  const { menus } = useMenuContext();

  const [renderedMenus, setRenderedMenus] = useState<JSX.Element[]>();
  const [renderedConfigMenus, setRenderedConfigMenus] =
    useState<JSX.Element[]>();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const checkScreenSize = () => {
    setIsSmallScreen(window.innerWidth < 992); // Bootstrap usa `lg` para colapso, que é 992px
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    checkMenus();
    const filteredMenus = menus.filter((item) => !item.config);
    const filteredConfigMenus = menus.filter((item) => item.config);

    setRenderedMenus(
      renderMenus(
        filteredMenus,
        filteredMenus.filter((item) => item.id_pagina_menu_pai === null),
        [],
        0
      )
    );

    setRenderedConfigMenus(
      renderMenus(
        filteredConfigMenus,
        filteredConfigMenus.filter((item) => item.id_pagina_menu_pai === null),
        [],
        0
      )
    );
  }, [menus]);

  const renderMenus = (
    menus: PaginasMenuAttributes[],
    menusLevel: PaginasMenuAttributes[],
    preRender: JSX.Element[],
    levelIndex: number
  ): JSX.Element[] => {
    menusLevel.forEach((item) => {
      const childrens = menus.filter(
        (ch) => ch.id_pagina_menu_pai === item.id_pagina_menu
      );

      const key = item.id_pagina_menu!.toString();

      if (childrens.length > 0) {
        preRender.push(
          <NavDropdown key={key} title={item.pagina} id={`nav-dropdown-${key}`}>
            {renderMenus(menus, childrens, [], levelIndex + 1)}
          </NavDropdown>
        );
      } else {
        if (item.id_pagina_menu_pai === null) {
          preRender.push(
            <Nav.Link key={key} as={Link} to={item.link ? item.link : ""}>
              {item.pagina}
            </Nav.Link>
          );
        } else {
          if (item.pagina === "{user}") {
            preRender.push(
              <NavDropdown.Item
                key={key}
                as={Link}
                to={item.link ? item.link : ""}
              >
                {new StringsFuncs(authToken?.nome).cammelCase()}
              </NavDropdown.Item>
            );
          } else {
            preRender.push(
              <NavDropdown.Item
                key={key}
                as={Link}
                to={item.link ? item.link : ""}
              >
                {item.pagina}
              </NavDropdown.Item>
            );
          }
        }
      }
    });

    return preRender;
  };

  return (
    <header className="header bg-light shadow-sm">
      <div>
        <Navbar expand="lg">
          <Container>
            <Link to="/">
              <Navbar.Brand>
                <img
                  src={logo}
                  height="50"
                  className="d-inline-block align-top"
                  alt="Company Logo"
                />
              </Navbar.Brand>
            </Link>

            {isSmallScreen && <NotificationsIconMenu />}

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse>
              <Nav className="me-auto">{renderedMenus}</Nav>
              <Nav>
                {!isSmallScreen && <NotificationsIconMenu />}
                {renderedConfigMenus}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
};

export default PrivateMenu;
